import { Component, ElementRef, Input, Output, ViewChild, EventEmitter, OnChanges } from '@angular/core';
import { SummedMasterReport } from '../../domain/report/summed-master-report.model';
import { DateRangeHolder } from '../../../../shared/domain/date-range-holder.model';
import { SortUtils } from '../../../../shared/utils/sort-utils';
import { ReportsService } from '../../services/reports.service';
import { ReportRequestPresets } from '../../domain/report/report-request-presets.model';
import { ReportMetric, ReportMetricDetails, ReportMetricsAll } from '../../domain/report/report-metric.enum';
const Highcharts = require('highcharts/highcharts');

@Component({
  selector: 'cm-daily-metrics-chart',
  template: `
    <div class="p-2">
      <div #chart class="w-100"></div>
    </div>
  `,
  styles: [`
    /* Set in kitchen-dashboard.component.scss */
  `],
  host: { 'class': 'cm-daily-metrics-chart' }
})
export class DailyMetricsChartComponent implements OnChanges {
   @ViewChild('chart', {static: true}) chartEl: ElementRef;

  @Input()
  metrics: ReportMetric[];

  @Input()
  dateRange: DateRangeHolder;

  @Input()
  publisherIds: string[];

  @Output() loading = new EventEmitter();

  reportMetricDetails: ReportMetricDetails[] = [];

  constructor(private reportsService: ReportsService) {
  }

  ngOnChanges() {
    this.reportMetricDetails = ReportMetricsAll().filter(m => this.metrics.includes(m.key));
    this.loadChartData();
  }

  private renderChart(data: SummedMasterReport[]) {
    const opts: any = {
      chart: {
        zoomType: 'xy',
        height: 400,
        animation: false
      },
      title: {
        text: ' '
      },
      xAxis: [{
        categories: data.map(item => item.day),
        crosshair: true
      }],
      yAxis: this.reportMetricDetails.map(details => {
        return {
          title: {
            text: details.label,
          },
          opposite: false
        };
      }),
      tooltip: {
        shared: true,
        animation: false
      },
      series: this.reportMetricDetails.map((details, index) => {
        const settings = {
          name: details.label,
          yAxis: index,
          type: 'spline',
        };
        switch (details.key) {
          case ReportMetric.FILLED:
          case ReportMetric.MARGIN:
            Object.assign(settings, {
              data: data.map(item => (item[details.field] || 0) * 100),
            });
            break;
          default:
            Object.assign(settings, {
              data: data.map(item => item[details.field]),
            });
        }
        switch (details.key) {
          case ReportMetric.REFRESH_RATE:
            Object.assign(settings, {
              tooltip: {
                valueDecimals: 2,
              },
            });
            break;
          case ReportMetric.FILLED:
          case ReportMetric.MARGIN:
            Object.assign(settings, {
              tooltip: {
                valueDecimals: 2,
                valueSuffix: '%'
              },
            });
            break;
          case ReportMetric.PROFIT:
          case ReportMetric.REVENUE:
          case ReportMetric.RPM:
            Object.assign(settings, {
              tooltip: {
                valueDecimals: 2,
                valuePrefix: '$'
              },
            });
            break;
        }
        return settings;
      })
    };

    Highcharts.setOptions({
      global: {
        useUTC: false
      }
    });

    Highcharts.chart(this.chartEl.nativeElement, opts);
  }

  loadChartData() {
    const report = ReportRequestPresets.DAILY_FINANCIAL;
    report.metrics = this.metrics;
    Object.assign(report.filters, {
      dateFrom: this.dateRange.dateFrom,
      dateTo: this.dateRange.dateTo,
      publisherIds: this.publisherIds
    });
    this.loading.emit(true);
    this.reportsService.report(report).subscribe(next => {
      next.report.sort(SortUtils.propertyComparatorString('day'));

      this.renderChart(next.report);
      this.loading.emit(false);
    }, (error) => {
      this.loading.emit(false);
    });
  }

}

